import { ApiBase } from '@fg-services/api/models/api-base';

export class CuratedApi extends ApiBase {
  model = 'Curated';

  patchCommunities(fandoms) {
    return this.http.patch(this.modelBase, { fandoms });
  }
}
